// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.custom-dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 451px !important;
  max-width: 100% !important;
  background-color: #F6F6F6 !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 0 1rem !important;
  color: #333 !important;
  font-size: 1rem !important;
  box-shadow: none !important;
  height: 44.5px !important;
  min-height: 44.5px !important;
  cursor: pointer;
  box-sizing: border-box;
  gap: 0.5rem;
}

.custom-dropdown-trigger:hover {
  background-color: #EFEFEF !important;
}

.custom-dropdown-trigger:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255,140,0,0.2) !important;
}

.trigger-label {
  flex: 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.trigger-icon {
  flex-shrink: 0;
  width: 17.5px !important;
  height: 9.5px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.trigger-icon svg {
  width: 100%;
  height: 100%;
  transition: transform 0.2s ease;
}

.trigger-icon.open svg {
  transform: rotate(180deg);
}

/* Panel: solid white container (rendered in overlay) */
::ng-deep .custom-dropdown-overlay-pane {
  margin-top: 4px;
}

::ng-deep .custom-dropdown-panel {
  background-color: #ffffff;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  padding: 0.5rem;
  min-width: 100%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-height: 300px;
  overflow-y: auto;
}

/* Options: solid white pills; hover = light grey bg, dark text */
::ng-deep .custom-option {
  display: block;
  width: 100%;
  padding: 0.6rem 0.75rem;
  border: none;
  border-radius: 8px;
  background-color: #ffffff;
  color: #333;
  font-size: 0.95rem;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

::ng-deep .custom-option:hover,
::ng-deep .custom-option.selected {
  background-color: #f6f6f6;
  color: #000;
  font-weight: 500;
}

/* Custom scrollbar for panel */
::ng-deep .custom-dropdown-panel::-webkit-scrollbar {
  width: 6px;
}
::ng-deep .custom-dropdown-panel::-webkit-scrollbar-track {
  background: transparent;
}
::ng-deep .custom-dropdown-panel::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}
::ng-deep .custom-dropdown-panel::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/shared/custom-dropdown/custom-dropdown.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uDAAuD;AACvD;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n}\n\n.custom-dropdown-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 451px !important;\n  max-width: 100% !important;\n  background-color: #F6F6F6 !important;\n  border: none !important;\n  border-radius: 10px !important;\n  padding: 0 1rem !important;\n  color: #333 !important;\n  font-size: 1rem !important;\n  box-shadow: none !important;\n  height: 44.5px !important;\n  min-height: 44.5px !important;\n  cursor: pointer;\n  box-sizing: border-box;\n  gap: 0.5rem;\n}\n\n.custom-dropdown-trigger:hover {\n  background-color: #EFEFEF !important;\n}\n\n.custom-dropdown-trigger:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(255,140,0,0.2) !important;\n}\n\n.trigger-label {\n  flex: 1;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.trigger-icon {\n  flex-shrink: 0;\n  width: 17.5px !important;\n  height: 9.5px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.trigger-icon svg {\n  width: 100%;\n  height: 100%;\n  transition: transform 0.2s ease;\n}\n\n.trigger-icon.open svg {\n  transform: rotate(180deg);\n}\n\n/* Panel: solid white container (rendered in overlay) */\n::ng-deep .custom-dropdown-overlay-pane {\n  margin-top: 4px;\n}\n\n::ng-deep .custom-dropdown-panel {\n  background-color: #ffffff;\n  border-radius: 10px;\n  border: 1px solid #e0e0e0;\n  padding: 0.5rem;\n  min-width: 100%;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n/* Options: solid white pills; hover = light grey bg, dark text */\n::ng-deep .custom-option {\n  display: block;\n  width: 100%;\n  padding: 0.6rem 0.75rem;\n  border: none;\n  border-radius: 8px;\n  background-color: #ffffff;\n  color: #333;\n  font-size: 0.95rem;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n::ng-deep .custom-option:hover,\n::ng-deep .custom-option.selected {\n  background-color: #f6f6f6;\n  color: #000;\n  font-weight: 500;\n}\n\n/* Custom scrollbar for panel */\n::ng-deep .custom-dropdown-panel::-webkit-scrollbar {\n  width: 6px;\n}\n::ng-deep .custom-dropdown-panel::-webkit-scrollbar-track {\n  background: transparent;\n}\n::ng-deep .custom-dropdown-panel::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 10px;\n}\n::ng-deep .custom-dropdown-panel::-webkit-scrollbar-thumb:hover {\n  background: #aaa;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
